import { mapData } from "@/utilities/DataMapping";
import ApiClient from "@/utilities/ApiClient";

export interface IMapplicOption {
    id: string;
    siteId: number;
    folderName: string;
    description: string;
}

export class MapplicOption implements IMapplicOption {

    constructor(data?: IMapplicOption) {
        if (data) {
            this.update(data);
        }
        else {
            this.description = "- - -";
        }
    }

    update(data: IMapplicOption): MapplicOption {
        mapData(data, { root: () => this });
        return this;
    }

    id: string = "";
    siteId: number = 0;
    folderName: string = "";
    description: string = "";

    get href() {
        return ApiClient.resolveUrl(this.folderName);
    }
}
